var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-4 border rounded"},[_vm._v("\n  An error occured while loading the module. Please try again.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }